import getSrpUrlParams from './get-srp-url-params';
import isSEM from './is-sem';
import { SEO_SEARCH_STRING } from '@stencil/flights-constants/src/default-values';
import { SRP_URL, NEW_FLIGHTS_URL } from '@stencil/flights-constants/src/urls';

const getSrpUrl = (
  searchWidgetData,
  searchParams,
  isGroundup = false,
  selectedFareIdentifier = ''
) => {
  const DOMESTIC = 'domestic';
  const isDomestic = searchWidgetData?.travelType === DOMESTIC;
  const srpURLParams = getSrpUrlParams(searchWidgetData, isGroundup, selectedFareIdentifier);

  const isSem = isSEM();
  const searchString = isSem ? location?.search : `?${SEO_SEARCH_STRING}`;

  if (isGroundup && isDomestic) {
    return `${window.location.origin}${NEW_FLIGHTS_URL}air-${srpURLParams}/${searchString}${searchParams}`;
  }

  return `${window.location.origin}${SRP_URL}${srpURLParams}/${searchString}${searchParams}`;
};

export default getSrpUrl;
